export function maskAccountValue(value) {
  if (!value) {
    return ''
  }

  if (value.length <= 10) {
    return value
  }

  return `${value.substring(0, 5)}...${value.substring(value.length - 4)}`
}

function normalizeAccount(value) {
  return value ? value.toUpperCase() : value
}

function evaluateExpectedAccount(expectedAccount, metaAccount) {
  if (!metaAccount) {
    return {
      res: '0',
      reason: 'missing_wallet_account',
      expectedAccount
    }
  }

  if (expectedAccount && normalizeAccount(expectedAccount) !== metaAccount) {
    return {
      res: '0',
      reason: 'account_mismatch',
      expectedAccount
    }
  }

  return { res: '1' }
}

export function evaluateMetaMaskAccess({
  initOk,
  isInstall,
  userType,
  userAccount,
  metaAccount,
  foundationManager,
  auditor
}) {
  if (!initOk) {
    return { res: '1' }
  }

  if (!isInstall) {
    return { res: '-1', reason: 'not_installed' }
  }

  const normalizedMetaAccount = normalizeAccount(metaAccount)

  switch (Number(userType)) {
    case 0:
      return evaluateExpectedAccount(userAccount, normalizedMetaAccount)
    case 1:
      return evaluateExpectedAccount(foundationManager, normalizedMetaAccount)
    case 2:
      return evaluateExpectedAccount(auditor, normalizedMetaAccount)
    default:
      return { res: '1' }
  }
}
